/**
 * Utilitário para obter URL do Supabase no contexto do Widget
 * 
 * Prioridade:
 * 1. __SUPABASE_URL__ (injetado no build do widget embed)
 * 2. import.meta.env.VITE_SUPABASE_URL (aplicação principal)
 * 
 * @version 1.0.0
 */

import { createLogger } from '@/lib/logger';

// Logger para diagnóstico
const logger = createLogger('WidgetSupabase');

// Variáveis injetadas no build do widget
declare const __SUPABASE_URL__: string;
declare const __SUPABASE_ANON_KEY__: string;

/**
 * Obtém a URL do Supabase de forma segura
 * Funciona tanto no widget embed quanto no preview dentro da aplicação
 */
export function getSupabaseUrl(): string {
  // Prioridade 1: Variável injetada no build do widget
  if (typeof __SUPABASE_URL__ !== 'undefined' && __SUPABASE_URL__) {
    return __SUPABASE_URL__;
  }
  
  // Prioridade 2: Variável de ambiente do Vite (aplicação principal)
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_URL) {
    logger.debug('Usando VITE_SUPABASE_URL para o widget');
    return import.meta.env.VITE_SUPABASE_URL;
  }
  
  logger.warn('URL do Supabase não configurada');
  return '';
}

/**
 * Obtém a chave anônima do Supabase de forma segura
 * Funciona tanto no widget embed quanto no preview dentro da aplicação
 */
export function getSupabaseAnonKey(): string {
  // Prioridade 1: Variável injetada no build do widget
  if (typeof __SUPABASE_ANON_KEY__ !== 'undefined' && __SUPABASE_ANON_KEY__) {
    return __SUPABASE_ANON_KEY__;
  }
  
  // Prioridade 2: Variável de ambiente do Vite (aplicação principal)
  // Nota: O .env usa VITE_SUPABASE_PUBLISHABLE_KEY (que é a anon key)
  if (typeof import.meta !== 'undefined' && import.meta.env?.VITE_SUPABASE_PUBLISHABLE_KEY) {
    logger.debug('Usando VITE_SUPABASE_PUBLISHABLE_KEY para o widget');
    return import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
  }
  
  logger.warn('Chave anônima do Supabase não configurada');
  return '';
}
